import React from "react";

import { ImageChooserBlock as ImageChooserBlockValue } from "@reactivated";

import { concatClassNames } from "../../utils/styles";
import { ImageRenditionSet } from "../ImageRenditionSet";

import styles from "./index.module.scss";

export const ImageChooserBlock = (props: {
    value: ImageChooserBlockValue;
    /** Attributes are set on the picture element */
    attrs?: React.HTMLAttributes<HTMLPictureElement>;
    /** Attributes are set on the image element */
    imageAttrs?: React.ImgHTMLAttributes<HTMLImageElement>;
    /**
     * Just a regular sizes attribute, but because it goes on the <source>
     * element and there's no other need for sourceAttrs, it's by itself.
     * https://html.spec.whatwg.org/multipage/images.html#sizes-attribute
     */
    sizes?: string;
    renditionNames?: Set<string>;
    /**
     * ImageChooserBlock allows the direct use of image data if the file
     * is under a certain (configurable) threshold. It will use the data
     * if it exists unless this variable exists and is set to false
     */
    useImageData?: boolean;
}) => {
    const attrs = props.attrs || {};
    attrs.className = concatClassNames([attrs.className, styles.picture]);
    const imageAttrs = props.imageAttrs || {};
    imageAttrs.className = concatClassNames([imageAttrs.className, styles.img]);
    // Use Wagtail's computed default_alt_text (description or title fallback)
    if (typeof imageAttrs.alt === "undefined") {
        imageAttrs.alt = props.value.default_alt_text;
    }
    // Find all the renditions we should use for the srcSet, and sort them from smallest to largest filesize
    const renditions = Object.entries(props.value.renditions)
        .filter(([name]) => {
            return (
                props.renditionNames === undefined ||
                props.renditionNames.has(name)
            );
        })
        .map(([, rendition]) => rendition);

    // SVGs allow the possibility of delivering markup directly, so...drop it in!
    const useImageData = props.useImageData ?? true;
    if (props.value.imageData && useImageData) {
        return (
            <div
                dangerouslySetInnerHTML={{ __html: props.value.imageData }}
                className="imageDataWrapper"
            ></div>
        );
    }
    return (
        <ImageRenditionSet
            renditions={renditions}
            attrs={attrs}
            imageAttrs={imageAttrs}
            sizes={props.sizes}
        />
    );
};
